import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoSaludMental({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [nombre, setNombre] = useState("");
  const [servicio, setServicio] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");
  const [loading, setLoading] = useState(false);

  const openModal = () => setIsOpen(true);

  const closeModal = () => {
    setIsOpen(false);
    setNombre("");
    setServicio("");
    setCargo("");
    setLider("");
    setLoading(false);
  };

  const postData = (e) => {
    e.preventDefault();
    setLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoSaludMental",
      data: { nombre, servicio, cargo, lider, SolicitudId: idSolicitud },
    })
      .then(() => {
        alert("Añadido con éxito!");
        closeModal();
        if (onCreated) onCreated(); // Actualiza la tabla en el padre
      })
      .catch((err) => {
        console.log(err);
        alert("Error al crear el equipo: " + err);
        setLoading(false);
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={openModal}>
        Nueva
      </button>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="container text-center">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Crea Equipo Primario de Mejoramiento de Psicología y Salud
                Mental
              </h6>
            </div>
            <div className="card-body">
              <form className="user" onSubmit={postData}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control form-control-user"
                    placeholder="Nombre"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group row">
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <input
                      type="text"
                      className="form-control form-control-user"
                      placeholder="Servicio"
                      value={servicio}
                      onChange={(e) => setServicio(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control form-control-user"
                      placeholder="Cargo"
                      value={cargo}
                      onChange={(e) => setCargo(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <select
                    className="btn btn-secondary btn-user btn-block"
                    value={lider}
                    onChange={(e) => setLider(e.target.value)}
                    required
                  >
                    <option value="">Es Lider?</option>
                    <option value="Si">SI</option>
                    <option value="No">NO</option>
                  </select>
                </div>
                <button
                  className="btn btn-primary btn-user btn-block"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Guardando..." : "Guardar"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaEquipoSaludMental;
